export default __webpack_public_path__ + "static/media/home-active.0a3a8728.svg";